import { Box3, Vector3 } from 'three';

// Scratch storage belongs to one viewport, with no per-frame allocations.
export const createFollowScratch = () => ({ position: new Vector3(), delta: new Vector3(), bounds: new Box3() });

export function updateFollowCamera(key, objects, camera, controls, scratch) {
    const object = objects.get(key);
    if (!object?.parent || !camera || !controls) return false;
    if (key.startsWith('zone:')) {
        scratch.bounds.setFromObject(object);
        if (scratch.bounds.isEmpty()) return false;
        scratch.bounds.getCenter(scratch.position);
    } else {
        object.getWorldPosition(scratch.position);
    }
    scratch.delta.copy(scratch.position).sub(controls.target);
    camera.position.add(scratch.delta);
    controls.target.copy(scratch.position);
    return true;
}
